var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6665_18371",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6665_18371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2222 28C5.6222 28 5.10183 27.7796 4.6611 27.3389C4.22037 26.8982 4 26.3778 4 25.7778V6.2222C4 5.6222 4.22037 5.10183 4.6611 4.6611C5.10183 4.22037 5.6222 4 6.2222 4H21.3778L28 10.6222V25.7778C28 26.3778 27.7796 26.8982 27.3389 27.3389C26.8982 27.7796 26.3778 28 25.7778 28H6.2222ZM6.2222 25.7778H25.7778V11.8095H20.2V6.2222H6.2222V25.7778ZM9.3111 22.4222H22.6889V20.2H9.3111V22.4222ZM9.3111 11.8H16V9.5778H9.3111V11.8ZM9.3111 17.1111H22.6889V14.8889H9.3111V17.1111Z",
    fill: "#054BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.034345aa2a1d5b239d36b3cc6925731b.svg";
export { ForwardRef as ReactComponent };